export function randomUUID() {
  let template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return template.replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0, // Tạo số ngẫu nhiên từ 0-15
      v = c === 'x' ? r : (r & 0x3) | 0x8; // Nếu là 'x', lấy r, nếu là 'y' lấy (r & 0x3 | 0x8)
    return v.toString(16); // Chuyển số thành hệ 16 (hex)
  });
}
